export const gitCommit = '8db5076c'
